import { Button, Space, Typography } from 'antd'
import {
  PaperClipOutlined,
  DownloadOutlined,
  CloseCircleFilled,
} from '@ant-design/icons'
import { useRef, useEffect, useCallback } from 'react'

const { Text } = Typography

export default function UploadFileCustom({
  fileUrl,
  fileName,
  onSelectFile,
  onRemoveFile,
  accept,
  fileBase64,
}) {
  const inputRef = useRef(null)

  // ✅ Log CHỈ khi fileUrl thay đổi
  useEffect(() => {
    if (fileUrl) {
      console.log('fileUrl', fileUrl)
    }
  }, [fileUrl])

  const handleChange = useCallback(
    (e) => {
      const file = e.target.files?.[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = () => {
        onSelectFile?.({
          file,
          base64: reader.result,
        })
      }

      reader.onerror = () => {
        console.error('Không đọc được file')
      }

      reader.readAsDataURL(file)

      e.target.value = ''
    },
    [onSelectFile],
  )

  const handleChooseFile = useCallback(() => {
    inputRef.current?.click()
  }, [])

  const downloadFile = useCallback((fileUrl, fileName, fileBase64) => {
    // 1️⃣ Có base64 → tải từ client
    if (fileBase64) {
      const [meta, data] = fileBase64.split(',')
      const mime =
        meta?.match(/data:(.*);base64/)?.[1] || 'application/octet-stream'

      const binary = atob(data)
      const bytes = new Uint8Array(binary.length)

      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i)
      }

      const blob = new Blob([bytes], { type: mime })
      const url = URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = url
      a.download = fileName || 'download'
      a.click()

      URL.revokeObjectURL(url)
      return
    }

    // 2️⃣ Không có base64 → mở link backend
    if (fileUrl) {
      window.open(fileUrl, '_blank')
    }
  }, [])

  return (
    <div className="w-100">
      <input
        ref={inputRef}
        type="file"
        hidden
        accept={accept}
        onChange={handleChange}
      />

      <Space size={8}>
        <Button
          icon={<PaperClipOutlined />}
          onClick={handleChooseFile}
          style={{ height: 40 }}
        >
          Chọn tệp
        </Button>

        {fileName && (
          <Space size={4}>
            {fileUrl || fileBase64 ? (
              <a
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4,
                  cursor: 'pointer',
                }}
                onClick={() => downloadFile(fileUrl, fileName, fileBase64)}
              >
                <DownloadOutlined style={{ color: '#5794eb' }} />
                <Text>{fileName}</Text>
              </a>
            ) : (
              <Text>{fileName}</Text>
            )}

            <CloseCircleFilled
              title="Xóa"
              style={{
                color: '#ff4d4f',
                cursor: 'pointer',
                fontSize: 14,
              }}
              onClick={onRemoveFile}
            />
          </Space>
        )}
      </Space>
    </div>
  )
}
